export default {
    "joy-palette": {
        // Primary
        "primary-50": {
            value: "var(--color-brand-primary-50)",
        },
        "primary-100": {
            value: "var(--color-brand-primary-100)",
        },
        "primary-200": {
            value: "var(--color-brand-primary-200)",
        },
        "primary-300": {
            value: "var(--color-brand-primary-300)",
        },
        "primary-400": {
            value: "var(--color-brand-primary-400)",
        },
        "primary-500": {
            value: "var(--color-brand-primary-500)",
        },
        "primary-600": {
            value: "var(--color-brand-primary-600)",
        },
        "primary-700": {
            value: "var(--color-brand-primary-700)",
        },
        "primary-800": {
            value: "var(--color-brand-primary-800)",
        },
        "primary-900": {
            value: "var(--color-brand-primary-900)",
        },
        // Neutral
        "neutral-50": {
            value: "var(--color-brand-neutral-50)",
        },
        "neutral-100": {
            value: "var(--color-brand-neutral-100)",
        },
        "neutral-200": {
            value: "var(--color-brand-neutral-200)",
        },
        "neutral-300": {
            value: "var(--color-brand-neutral-300)",
        },
        "neutral-400": {
            value: "var(--color-brand-neutral-400)",
        },
        "neutral-500": {
            value: "var(--color-brand-neutral-500)",
        },
        "neutral-600": {
            value: "var(--color-brand-neutral-600)",
        },
        "neutral-700": {
            value: "var(--color-brand-neutral-700)",
        },
        "neutral-800": {
            value: "var(--color-brand-neutral-800)",
        },
        "neutral-900": {
            value: "var(--color-brand-neutral-900)",
        },
        // Warning
        "warning-50": {
            value: "var(--color-brand-warning-50)",
        },
        "warning-100": {
            value: "var(--color-brand-warning-100)",
        },
        "warning-200": {
            value: "var(--color-brand-warning-200)",
        },
        "warning-300": {
            value: "var(--color-brand-warning-300)",
        },
        "warning-400": {
            value: "var(--color-brand-warning-400)",
        },
        "warning-500": {
            value: "var(--color-brand-warning-500)",
        },
        "warning-600": {
            value: "var(--color-brand-warning-600)",
        },
        "warning-700": {
            value: "var(--color-brand-warning-700)",
        },
        "warning-800": {
            value: "var(--color-brand-warning-800)",
        },
        "warning-900": {
            value: "var(--color-brand-warning-900)",
        },
        // Danger
        "danger-50": {
            value: "var(--color-brand-danger-50)",
        },
        "danger-100": {
            value: "var(--color-brand-danger-100)",
        },
        "danger-200": {
            value: "var(--color-brand-danger-200)",
        },
        "danger-300": {
            value: "var(--color-brand-danger-300)",
        },
        "danger-400": {
            value: "var(--color-brand-danger-400)",
        },
        "danger-500": {
            value: "var(--color-brand-danger-500)",
        },
        "danger-600": {
            value: "var(--color-brand-danger-600)",
        },
        "danger-700": {
            value: "var(--color-brand-danger-700)",
        },
        "danger-800": {
            value: "var(--color-brand-danger-800)",
        },
        "danger-900": {
            value: "var(--color-brand-danger-900)",
        },
        // Success
        "success-50": {
            value: "var(--color-brand-success-50)",
        },
        "success-100": {
            value: "var(--color-brand-success-100)",
        },
        "success-200": {
            value: "var(--color-brand-success-200)",
        },
        "success-300": {
            value: "var(--color-brand-success-300)",
        },
        "success-400": {
            value: "var(--color-brand-success-400)",
        },
        "success-500": {
            value: "var(--color-brand-success-500)",
        },
        "success-600": {
            value: "var(--color-brand-success-600)",
        },
        "success-700": {
            value: "var(--color-brand-success-700)",
        },
        "success-800": {
            value: "var(--color-brand-success-800)",
        },
        "success-900": {
            value: "var(--color-brand-success-900)",
        },
    },
};
